export const EMAIL_REFERRAL = "EMAIL_REFERRAL";
export const LINK_REFERRAL = "LINK_REFERRAL";